import React from "react";
import shortid from "shortid";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import * as R from "ramda";

export default function useLinkedinAuth(callback) {
  const history = useHistory();
  const companyId = useSelector(R.path(["company", "id"]));

  function authorize() {
    const url = new URL(window.location.href);

    url.searchParams.set("companyId", companyId);
    localStorage.setItem("redirect_uri", url.href);

    window.location.href = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${
      process.env.REACT_APP_LI_APP
    }&redirect_uri=${
      process.env.REACT_APP_LI_REDIRECT_URL
    }&state=${shortid.generate()}&scope=r_liteprofile%20r_emailaddress%20w_member_social`;
  }

  React.useEffect(() => {
    const url = new URL(window.location.href);
    const code = url.searchParams.get("code");

    if (code) {
      // Remove url params to prevent connecting multiple times
      history.replace(history.location.pathname);

      callback(code);
    }
  }, [callback, history]);

  return authorize;
}
